import {
    AccessBayScheduling,
    AccessHaulerManagement,
    AccessPlantManagement,
    AccessProducerManagement,
    CanImpersonateUsers,
    Dashboard,
    GetFluidScheduleDetails,
    GetMilkScheduleDetails,
    ListAdmins,
    ListBactoAlert,
    ListCIPWash,
    ListDrivers,
    ListDropoffs,
    ListHaulingCompanies,
    ListInvoicing,
    ListLabReports,
    ListManifests,
    ListMonthlyReports,
    ListPickups,
    ListPickupsAndLabs,
    ListProcessors,
    ListProducers,
    ListReceivers,
    ListRouteSessions,
    ListScheduleRoutes,
    ListSharedFiles,
    ListSilos,
    ListSubAdmins,
    ListSubHauling,
    ListSubProcessors,
    ListSubProducers,
    ListTrailers,
    ListUserGroups,
    ManageAssignees,
    ManageAssignments,
    ManageBankingInfo,
    ManageClosePeriod,
    ManageCustomFields,
    ManageDeferrals,
    ManageDeliveryReports,
    ManageHaulerPayReports,
    ManageLinkedUsers,
    ManageMerchandise,
    ManageMooRules,
    ManagePaymentStatus,
    ManagePoolingDecisions,
    ManageProcessedFluidsDropoffs,
    ManageProcessedFluidsPickups,
    ManageProcessedFluidsRouteSessions,
    ManageProcessorTotals,
    ManageProducerPayReports,
    ManageProducerTouchBases,
    ManageRapidTest,
    ManageSplitProducers,
    ManageVendorPayReports,
    ProducerHaulingContractsAndCharges,
    QARapidTest,
    UploadDownload,
    UploadMooRules,
    ViewAccountingReports,
    ViewDocumentation,
    ViewDriverLocations,
    ViewHaulerPayReport,
    ViewPricing,
    ViewReceivingDropoffs,
    ViewMilkPredictionReport,
    ViewContractPerformanceReport,
    ViewSupplyOutlookReport,
} from './permissions';
import LABELS from './constants';

const region = 'DEFAULT';

const SubAdminUsersAndAssets = {
    label: LABELS.UsersAndAssets,
    permissions: [
        ListSubAdmins,
        ListAdmins,
        ListProducers,
        ListSubProducers,
        ListProcessors(region),
        ListSubProcessors(region),
        ListTrailers,
        ListHaulingCompanies(region),
        ListSubHauling(region),
        ListDrivers,
        ListSilos,
        ListUserGroups,
        AccessProducerManagement,
        AccessPlantManagement,
        AccessHaulerManagement,
        ManageLinkedUsers,
        CanImpersonateUsers,
        // force wrap
    ],
};

const SubAdminGeneral = {
    label: LABELS.General,
    permissions: [
        Dashboard,
        UploadDownload,
        AccessBayScheduling,
        ManageCustomFields,
        ViewMilkPredictionReport,
        ViewContractPerformanceReport,
        ViewSupplyOutlookReport,
        // wrap
    ],
};

const SubAdminRawMilkTracking = {
    label: LABELS.RawMilkTracking,
    permissions: [
        GetMilkScheduleDetails(),
        ListRouteSessions(region),
        ListScheduleRoutes,
        ListDropoffs(),
        ListPickups(),
        ListCIPWash,
        ListManifests,
        ViewDriverLocations,
        ManageDeliveryReports,
        ManageClosePeriod,
        ViewReceivingDropoffs,
        // wrap
    ],
};

const SubAdminProcessedFluidTracking = {
    label: LABELS.ProcessedFluidTracking,
    permissions: [
        GetFluidScheduleDetails,
        ManageProcessedFluidsPickups,
        ManageProcessedFluidsDropoffs,
        ManageProcessedFluidsRouteSessions,
        // wrap
    ],
};

const SubAdminPayroll = {
    label: LABELS.Payroll,
    permissions: [
        ManageProducerPayReports,
        ManageHaulerPayReports,
        ViewHaulerPayReport,
        ManageVendorPayReports,
        ManagePaymentStatus,
        ManageAssignees,
        ManageDeferrals,
        ManageMerchandise(region),
        ManageSplitProducers,
        ManageMooRules,
        UploadMooRules,
        ManageAssignments,
        ViewPricing,
        // wrap
    ],
};

const SubAdminInvoicing = {
    label: LABELS.Invoicing,
    permissions: [
        ViewAccountingReports,
        ManageBankingInfo,
        ListInvoicing,
        // wrap
    ],
};

const SubAdminMemberships = {
    label: LABELS.Memberships,
    permissions: [
        ListSharedFiles,
        ViewDocumentation,
        // wrap
    ],
};

const SubAdminQuality = {
    label: LABELS.Quality,
    permissions: [
        ListLabReports(),
        ManageRapidTest,
        QARapidTest,
        // wrap
    ],
};

const SubAdminPooling = {
    label: LABELS.Pooling,
    permissions: [ManagePoolingDecisions, ManageProcessorTotals, ManageProducerTouchBases],
};

const SubProducerPermissions = {
    label: LABELS.SubProducerLabel,
    permissions: [
        Dashboard,
        ListPickups('View', ''),
        ListLabReports('View', ''),
        ListBactoAlert(region),
        ListPickupsAndLabs,
        ListSharedFiles,
        AccessProducerManagement,
        ListSubProducers,
        ListMonthlyReports(region),
        // force wrap
    ],
};

const SubProcessorGeneral = {
    label: LABELS.General,
    permissions: [
        Dashboard,
        AccessPlantManagement,
        AccessBayScheduling,
        UploadDownload,
        // force wrap
    ],
};

const SubProcessorRawMilkTracking = {
    label: LABELS.RawMilkTracking,
    permissions: [
        GetMilkScheduleDetails(),
        ListRouteSessions(region, 'View', ''),
        ListDropoffs('View', ''),
        ViewReceivingDropoffs,
        // force wrap
    ],
};

const SubProcessorProcessedFluidTracking = {
    label: LABELS.ProcessedFluidTracking,
    permissions: [
        GetFluidScheduleDetails,
        ManageProcessedFluidsPickups,
        ManageProcessedFluidsDropoffs,
        ManageProcessedFluidsRouteSessions,
        // force wrap
    ],
};

const SubProcessorInvoicing = {
    label: LABELS.Invoicing,
    permissions: [
        ListInvoicing,
        // force wrap
    ],
};

const SubProcessorMemberships = {
    label: LABELS.Memberships,
    permissions: [
        ListSharedFiles,
        // force wrap
    ],
};

const SubProcessorUsersAndAssets = {
    label: LABELS.UsersAndAssets,
    permissions: [
        ListReceivers,
        ListSubProcessors(region),
        ListSilos,
        // force wrap
    ],
};

const SubHaulingGeneral = {
    label: LABELS.General,
    permissions: [
        Dashboard,
        AccessHaulerManagement,
        UploadDownload,
        // force wrap
    ],
};

const SubHaulingRawMilkTracking = {
    label: LABELS.RawMilkTracking,
    permissions: [
        GetMilkScheduleDetails('View', ''),
        ListRouteSessions(region),
        ListPickups(),
        ListDropoffs(),
        ViewDriverLocations,
        ListCIPWash,
        ViewReceivingDropoffs,
        // force wrap
    ],
};

const SubHaulingProcessedFluidTracking = {
    label: LABELS.ProcessedFluidTracking,
    permissions: [
        GetFluidScheduleDetails,
        // force wrap
    ],
};

const SubHaulingPayroll = {
    label: LABELS.Payroll,
    permissions: [
        ViewHaulerPayReport,
        ProducerHaulingContractsAndCharges,
        // force wrap
    ],
};

const SubHaulingMemberships = {
    label: LABELS.Memberships,
    permissions: [
        ListSharedFiles,
        // force wrap
    ],
};

const SubHaulingUsersAndAssets = {
    label: LABELS.UsersAndAssets,
    permissions: [
        ListDrivers,
        ListSubHauling(region),
        ListTrailers,
        // force wrap
    ],
};

const SubAdmin = [
    SubAdminGeneral,
    SubAdminRawMilkTracking,
    SubAdminProcessedFluidTracking,
    SubAdminQuality,
    SubAdminPayroll,
    SubAdminInvoicing,
    SubAdminMemberships,
    SubAdminUsersAndAssets,
    SubAdminPooling,
    // wrap
];

const SubProcessor = [
    SubProcessorGeneral,
    SubProcessorRawMilkTracking,
    SubProcessorProcessedFluidTracking,
    SubProcessorInvoicing,
    SubProcessorMemberships,
    SubProcessorUsersAndAssets,
    // wrap
];

const SubHauling = [
    SubHaulingGeneral,
    SubHaulingRawMilkTracking,
    SubHaulingProcessedFluidTracking,
    SubHaulingPayroll,
    SubHaulingMemberships,
    SubHaulingUsersAndAssets,
    // wrap
];

const SubProducer = [SubProducerPermissions];

const REQUIRED_PERMISSIONS = {
    Admin: [
        ListSilos, // wrap
        ListUserGroups,
        ManageClosePeriod,
        ListInvoicing,
        ListManifests,
        GetMilkScheduleDetails(),
        ListTrailers,
    ],
};

const DEFAULT = {
    Admin: { permissions: SubAdmin, required: REQUIRED_PERMISSIONS.Admin },
    'Sub-Admin': { permissions: SubAdmin },
    'Sub-Producer': { permissions: SubProducer },
    Accountant: { permissions: SubProducer },
    'Feed-Provider': { permissions: SubProducer },
    Nutritionist: { permissions: SubProducer },
    'Co-Owner': { permissions: SubProducer },
    'Sub-Processor': { permissions: SubProcessor },
    'Sub-Hauling': { permissions: SubHauling },
    Processor: { permissions: SubProcessor },
    Hauling: { permissions: SubHauling },
};

export default DEFAULT;
